import { render, staticRenderFns } from "./CompanyConfig.vue?vue&type=template&id=22c68687&scoped=true&"
import script from "./CompanyConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyConfig.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CompanyConfig.vue?vue&type=style&index=1&lang=css&"
import style2 from "./CompanyConfig.vue?vue&type=style&index=2&id=22c68687&scoped=true&lang=css&"
import style3 from "./CompanyConfig.vue?vue&type=style&index=3&id=22c68687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c68687",
  null
  
)

export default component.exports